<template>
  <div class="team">
    <page-header />
    <page-prompt />
    <audit-temp :audit_status="audit_status" :audit_remark="audit_remark" />
    <section class="main">
      <h2 class="title">参赛者</h2>
      <div class="msgs">
        <el-button v-if="!inputDisabled" type="primary" icon="el-icon-plus" @click="onShowDialogForm({})"
          plain>添加成员</el-button>
        <div class="student" v-for="item of student_list" :key="item.id">
          <div class="operate">
            <el-button v-if="!inputDisabled" type="success" icon="el-icon-edit-outline" size="mini"
              @click="onShowDialogForm(item)">编辑</el-button>
            <el-button v-if="!inputDisabled" type="danger" icon="el-icon-delete" size="mini"
              @click="onDelStudent(item.id)">删除</el-button>
          </div>
          <ul>
            <li>
              <label>姓名：</label>
              <span>{{ item.name }}</span>
            </li>
            <li>
              <label>队内排名</label>
              <span>{{ item.position }}</span>
            </li>
            <li>
              <label>身份证号</label>
              <span>{{ item.identity }}</span>
            </li>
            <li>
              <label>性别：</label>
              <span>{{ sex_config_obj[item.sex] }}</span>
            </li>
            <li>
              <label>手机号：</label>
              <span>{{ item.phone }}</span>
            </li>
            <li>
              <label>电子邮箱：</label>
              <span>{{ item.email }}</span>
            </li>
            <li>
              <label>学校名称：</label>
              <span>{{ item.school_name }}</span>
            </li>
            <li>
              <label>学院名称：</label>
              <span>{{ item.college }}</span>
            </li>
            <li>
              <label>专业名称：</label>
              <span>{{ item.major }}</span>
            </li>
            <li>
              <label>学号：</label>
              <span>{{ item.student_id }}</span>
            </li>
            <li>
              <label>学生类型：</label>
              <template v-for="it of student_type2_config">
                <span :key="it.id" v-if="it.id === item.student_type">{{ it.name }}</span>
              </template>
            </li>
            <li>
              <label>入学年份：</label>
              <span>{{ item.dates }}</span>
            </li>
            <li>
              <label>年级：</label>
              <span>{{ item.grade }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
        <el-button type="primary" icon="el-icon-right" @click="onNextPage">下一项</el-button>
      </div>
    </section>

    <el-dialog :fullscreen="true" title="成员信息" center :visible.sync="dialogFormVisible" :show-close="false">
      <div class="form">
        <el-form label-position="top">
          <el-form-item label="姓名" :required="true">
            <el-input v-model="ac_student.name" placeholder="请填写姓名..." :disabled="student_list.length === 0" />
          </el-form-item>
          <el-form-item label="队内排名" :required="true">
            <el-input-number v-model="ac_student.position" :step="1" :min="1" :max="5" step-strictly
              :disabled="student_list.length === 0"></el-input-number>
          </el-form-item>
          <el-form-item label="身份证号" :required="true">
            <el-input v-model="ac_student.identity" placeholder="请填写身份证号..." :disabled="student_list.length === 0" />
          </el-form-item>
          <el-form-item label="性别" :required="true">
            <el-radio-group v-model="ac_student.sex">
              <el-radio v-for="item of sex_config" :key="item.key" :label="item.key">{{ item.title }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号" :required="true">
            <el-input v-model="ac_student.phone" placeholder="请填写手机号码..." :disabled="student_list.length === 0" />
          </el-form-item>
          <el-form-item label="电子邮箱" :required="true">
            <el-input v-model="ac_student.email" placeholder="请填写电子邮箱..." />
          </el-form-item>
          <el-form-item label="学校名称" :required="true">
            <el-input v-model="ac_student.school_name" placeholder="请填写学校名称..." />
          </el-form-item>
          <el-form-item label="学院名称" :required="true">
            <el-input v-model="ac_student.college" placeholder="请填写学院名称..." />
          </el-form-item>
          <el-form-item label="专业名称" :required="true">
            <el-input v-model="ac_student.major" placeholder="请填写专业名称..." />
          </el-form-item>
          <el-form-item label="学号" :required="true">
            <el-input v-model="ac_student.student_id" placeholder="请填写学号..." />
          </el-form-item>
          <el-form-item label="学生类型" :required="true">
            <el-select v-model="ac_student.student_type" placeholder="请选择学生类型" style="width:100%;">
              <el-option v-for="item of student_type2_config" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入学年份" :required="true">
            <el-input v-model="ac_student.dates" placeholder="示例：2024年" />
          </el-form-item>
          <el-form-item label="年级" :required="true">
            <el-input v-model="ac_student.grade" placeholder="示例：专科二年级、本科二年级、硕士生二年级、博士生二年级" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancelStudent">取 消</el-button>
        <el-button type="primary" @click="onConfirmStudent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AuditTemp from '@/components/AuditTemp'
import PagePrompt from '@/components/PagePrompt'
import { fetchStudentList, setStudentItem, delStudentItem } from '@/service/api'

export default {
  name: 'PageTeam',
  components: {
    PageHeader,
    PagePrompt,
    AuditTemp
  },
  data () {
    return {
      audit_status: 3,
      audit_remark: '',
      dialogFormVisible: false,
      reg_preliminary_expire: false,
      sex_config: [
        { key: 1, title: '男' },
        { key: 2, title: '女' }
      ],
      sex_config_obj: {
        1: '男',
        2: '女'
      },
      reg_team_basic: {},
      student_list: [],
      ac_student: {
        student_type: ''
      },
      student_type2_config: []
    }
  },
  computed: {
    inputDisabled () {
      return this.audit_status === 2 || this.audit_status === 4 || this.audit_status === 5 || this.reg_preliminary_expire
    }
  },
  methods: {
    async getStudentList () {
      try {
        const data = await fetchStudentList()
        this.reg_preliminary_expire = data.reg_preliminary_expire
        this.student_list = data.reg_student_list
        this.reg_team_basic = data.reg_team_basic
        this.audit_status = data.reg_team_basic.audit_status
        this.audit_remark = data.reg_team_basic.audit_remark
        this.student_type2_config = data.student_type2_config
      } catch (error) {
        console.log('getStudentList error', error)
      }
    },
    onPrevPage () {
      this.$router.push('/basic')
    },
    onNextPage () {
      this.$router.push('/instructor')
    },
    onShowDialogForm (item) {
      if (this.student_list.length >= 5) {
        this.$alert(`团队学生最多5人`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      this.dialogFormVisible = true
      if (!item.student_type || item.student_type < 20) {
        item.student_type = this.student_type2_config[0].id
      }
      this.ac_student = item
      if (this.student_list.length === 0) {
        this.ac_student.name = this.reg_team_basic.contact
        this.ac_student.position = 1
        this.ac_student.identity = this.reg_team_basic.identity
        this.ac_student.phone = this.reg_team_basic.phone
      }
    },
    async onConfirmStudent () {
      if (!this.ac_student.name) {
        this.$alert(`请填写姓名`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.position) {
        this.$alert(`请填写队内排名`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.identity || this.ac_student.identity.length !== 18) {
        this.$alert(`请正确填写身份证号`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.sex) {
        this.$alert(`请选择性别`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.ac_student.phone))) {
        this.$alert(`请正确填写手机号码`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.ac_student.email))) {
        this.$alert(`请正确填写电子邮箱`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.school_name) {
        this.$alert(`请填写学校名称`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.college) {
        this.$alert(`请填写学院名称`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.major) {
        this.$alert(`请填写专业名称`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.dates) {
        this.$alert(`请填写入学年份`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.ac_student.grade) {
        this.$alert(`请填写年级`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })

      try {
        await setStudentItem(this.ac_student)
        loading.close()
        this.getStudentList()
        this.onCancelStudent()
      } catch (error) {
        loading.close()
        console.log('setBasic error', error)
        this.$alert(error, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    onCancelStudent () {
      this.dialogFormVisible = false
      this.ac_student = {}
    },
    onDelStudent (id) {
      this.$confirm('是否继续删除，删除后不可恢复? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        async () => {
          try {
            const loading = this.$loading({
              lock: true,
              text: '删除中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.8)'
            })
            await delStudentItem({ id })
            loading.close()
            this.getStudentList()
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
          } catch (error) {
            console.log('error:', error)
          }
        }
      ).catch(
        () => {
          console.log('取消删除')
        }
      )
    }
  },
  mounted () {
    document.body.style.height = 'auto'
    this.getStudentList()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
